import './UserControls.scss';

import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { ImpersonateUserButton } from './ImpersonateUserButton';
import { ResendUserInviteButton } from './ResendUserInviteButton';
import { SendPasswordResetButton } from './SendPasswordResetButton';
import { Tooltip } from 'antd';
import { UserLockStateToggleButton } from './UserLockStateToggleButton';
import { UserWithIssuerType } from '@sonar-software/sonar-core';

import React, { useEffect } from 'react';
import { useBoolean, useSonarSelector } from '@hooks';

const lockAllUsersSelectors = createAsyncSelectors((state) => state.admin.customers.byId.lockAllUsers.post);

export interface UserControlsProps {
	user?: UserWithIssuerType;
	shardName?: string;
}

export const UserControls: React.FC<UserControlsProps> = ({ user, shardName }) => {

	const [ lockOverride, setLockOverride ] = useBoolean(false);
	const isLocked = user?.isLocked || lockOverride;
	const arovyOwnedUser = user?.hasUsernameAndPassword || user?.ssoIssuerType === null;

	const lockAllUsersIsReceived = useSonarSelector(lockAllUsersSelectors.isReceived);

	useEffect(() => {
		if (lockAllUsersIsReceived) {
			setLockOverride.on();
		}
	}, [ lockAllUsersIsReceived, setLockOverride ]);

	if (!user || !shardName) {
		return null;
	}

	return (
		<div className='admin-user-controls'>
			<ImpersonateUserButton
				shardName={ shardName }
				userId={ user?.id }
				userIsLocked={ isLocked } />
			<UserLockStateToggleButton
				onChange={ setLockOverride.off }
				shardName={ shardName }
				user={ user }
				userIsLocked={ isLocked } />
			<Tooltip
				placement='bottom'
				title={ ADMIN_DASHBOARD_COPY.USER_UTILIZES_SSO }
				trigger={ arovyOwnedUser ? [] : 'hover' }>
				<SendPasswordResetButton
					shardName={ shardName }
					userId={ user?.id }
					userIsLocked={ isLocked || !arovyOwnedUser } />
			</Tooltip>
			<Tooltip
				placement='bottom'
				title={ ADMIN_DASHBOARD_COPY.USER_UTILIZES_SSO }
				trigger={ arovyOwnedUser ? [] : 'hover' }>
				<ResendUserInviteButton
					shardName={ shardName }
					userId={ user?.id }
					userIsLocked={ isLocked || !arovyOwnedUser } />
			</Tooltip>
		</div>
	);
};
